import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import SEOHead from '../SEO/SEOHead';

const TermsOfService = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <SEOHead
        title="Terms of Service | VerveAI"
        description="Terms of service and engagement conditions for VerveAI digital infrastructure and AI solutions."
        canonical="https://verveai.co/terms"
      />
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Last Updated: October 4, 2025
        </Typography>

        <Box mt={4}>
          <Typography variant="h6" gutterBottom>
            1. Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing or using the VerveAI website and services, you agree to be bound by these Terms of Service. 
            If you do not agree to these terms, please do not use our services.
          </Typography>

          <Typography variant="h6" gutterBottom>
            2. Description of Service
          </Typography>
          <Typography paragraph>
            VerveAI provides AI-powered tools and services. The services may change from time to time at our discretion.
          </Typography>

          <Typography variant="h6" gutterBottom>
            3. User Accounts
          </Typography>
          <Typography paragraph>
            You are responsible for maintaining the confidentiality of your account and password and for restricting 
            access to your computer. You agree to accept responsibility for all activities that occur under your account.
          </Typography>

          <Typography variant="h6" gutterBottom>
            4. User Conduct
          </Typography>
          <Typography paragraph>You agree not to:</Typography>
          <ul>
            <li>Use the service for any illegal purpose</li>
            <li>Upload or transmit any content that is unlawful, harmful, or infringing</li>
            <li>Interfere with or disrupt the service or servers</li>
            <li>Attempt to gain unauthorized access to any portion of the service</li>
          </ul>

          <Typography variant="h6" gutterBottom>
            5. Intellectual Property
          </Typography>
          <Typography paragraph>
            The service and its original content, features, and functionality are owned by VerveAI and are protected 
            by international copyright, trademark, and other intellectual property laws.
          </Typography>

          <Typography variant="h6" gutterBottom>
            6. Limitation of Liability
          </Typography>
          <Typography paragraph>
            In no event shall VerveAI be liable for any indirect, incidental, special, consequential, or punitive 
            damages resulting from your use of or inability to use the service.
          </Typography>

          <Typography variant="h6" gutterBottom>
            7. Changes to Terms
          </Typography>
          <Typography paragraph>
            We reserve the right to modify these terms at any time. We will provide notice of any changes by updating 
            the "Last Updated" date at the top of these terms.
          </Typography>

          <Typography variant="h6" gutterBottom>
            8. Contact Us
          </Typography>
          <Typography paragraph>
            If you have any questions about these Terms of Service, please contact us at 
            <a href="mailto:rds087@gmail.com" style={{ color: '#1976d2', textDecoration: 'none' }}>
              rds087@gmail.com
            </a>.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfService;
